import moment from 'moment';
import DCClogo from '../../assets/img/DCC-Logo.png';
import { isDateValid, isNumber, numberWithCommas } from '../../utils/customFunction';
import Config from '../../config';

export const mmMaturityOfCouponLetter = (transaction: any, securities: any, amtWords: any, transNetAmount: any, transGrossAmount: any) => {

    let date = new Date();
    let dateFormat = moment(date).format('LL');
    let q = "qrcodemmMaturityofCoupon";
    let id = `${Config.q_r_url}/admin/verify-transaction/` + transaction.txn_id;
    let txnId = transaction.txn_id;
    let branchName = '';
    let branchCity = '';
    //     if(transaction.branch != undefined){
    //         branchName = transaction.branch.split(',')[0];
    //         branchCity = transaction.branch.split(',')[1];
    //         branchName = branchCity === undefined ? branchName+',' : branchName;
    //         branchCity = branchCity === undefined ? '' : branchCity+',';
    // } 
    if (transaction.branch != undefined) {
        if (transaction.branch.includes('–')) {
            branchName = transaction.branch.split('–')[0];
            branchCity = transaction.branch.split('–')[1];
            branchName = branchCity === undefined ? branchName.trim() + ',' : branchName.trim() + ',';
            branchCity = branchCity === undefined ? '' : branchCity.trim() + '.';
        } else {
            branchName = transaction.branch + ',';
        }
    }

    setTimeout(() => {
        if (id != undefined) {
            var element = document.getElementById(q)!;
            if (element != null) {
                element.innerHTML = "";
            }
            var qrcode = new QRCode(document.getElementById(q), {
                width: 50,
                height: 50
            });
            qrcode.makeCode(id);
        }

    }, 500)

    let securityType = securities.map(u => u.security_type).join('|');
    const dueCouponDate = securities.map(u => isDateValid(u.last_coupon_date));
    const faceValue = securities.map(u => u.money_market_face_value);


    // String.prototype.removeDuplicate = function () {
    //     return Array.from(new Set(this.split('|'))).toString().replace(',', '');
    // }

    // securityType = securityType.removeDuplicate();

    function removeDuplicate(secType) {
        return Array.from(new Set(secType.split('|'))).toString().replace(',', '');
    }

    securityType = removeDuplicate(securityType);

    // const numberWithCommas = (amount:any) => {
    //     amount= amount || '0';
    //     return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    //   } 

    let netAmountSum = 0;

    const getData = (items) => {
        if (transaction.txnr_type === 'debtmarketinvestment') {
            let rows = '';

            for (let i = 0; i < items.length; i++) {
                rows += ` 
                <tr>
                    <td style="border: 1px solid #333">${items[i].security_type}</td>
                    <td style="border: 1px solid #333">${moment(items[i].issue_date).format('LL')}</td>
                    <td style="border: 1px solid #333">${moment(items[i].maturity_date).format('LL')}</td>
                    <td style="border: 1px solid #333"> ${isDateValid(moment(items[i].next_coupon_date).format('LL'))}  </td>
                    <td style="border: 1px solid #333">${parseFloat(isNumber(items[i].coupon_rate)).toFixed(4)}</td>
                    <td style="border: 1px solid #333">${numberWithCommas(parseFloat(isNumber(items[i].total_face_value)).toFixed(2))}</td>
                    <td style="border: 1px solid #333"> ${numberWithCommas(transaction.net_amount)} </td>   
                </tr>
            `
                netAmountSum += parseFloat(isNumber(transaction.net_amount));
            }
            return rows;
        }
    }

    return `<html> 
    <head>
        <title>MACS Trustee</title>
    </head>
    <body style="font-family:Arial">
        <header>
            <table width="100%">
            <tr>
                <td>
                    <img src="${DCClogo}" alt="Trustee" height="70" />
                </td>
                <td valign="bottom">
                </td>
                <td valign="bottom">
                </td>
                <td align="right" valign="bottom">
                <div>
                <div style='text-align: right; margin-top:10px; height:60%; float: right;' id="${q}">
                </div>
                <span style='text-align: right; font-size:9px; margin-right:-53px; margin-top:60px; float: right;'>${txnId}</span>
                </div>
                </td>
            </tr>
            </table>
        </header>
        <hr />
        <section>
            <table style="width: 100%;"><tr><td>${dateFormat}</td> </tr></table>
            <br />
            <div>The Chief Manager <br /> ${transaction.bank} <br />  ${branchName}<br />${branchCity}</div>
            <br />
            <div> Sub : <b style="border-bottom:1px solid black"> Coupon Maturity of (${securityType}) ${transaction.fund_account} .</b></div>
            <br />
            <div>Please note that <b> ${transaction.fund_account} </b> has Maturity of <b>${securityType}</b> as per details mention below.</div>
            <br />
            <div>Dear Sir/Madam,</div>
            <br />
            <div>
                This is with reference to the subject, Please note that ${transaction.fund_account} 
                has coupon Maturity of <b>${securityType}</b> - due on ${isDateValid(moment(transaction.next_coupon_date).format('LL'))} as per following
            </div>
            <table style="width: 100%;">

            <tr>
                <th style="border: 1px solid #333; width: 10%"> Security  </th>
                <th style="border: 1px solid #333; width: 15%"> Issue Date    </th>
                <th style="border: 1px solid #333; width: 15%"> Maturity Date    </th>
                <th style="border: 1px solid #333; width: 15%"> Next Coupon Date    </th>
                <th style="border: 1px solid #333; width: 10%"> Coupon Rate  </th>
                <th style="border: 1px solid #333; width: 15%"> Face Value   </th>
                <th style="border: 1px solid #333; width: 20%"> Coupon Maturity Amount   </th>
            </tr>

         

            ${getData(securities)}
               
            </table>
            
            <br />
            <table>
                <tr> 
                    <td>
                    You are requested to kindly transfer coupon maturity amount ${numberWithCommas(netAmountSum)} into account number <b> ${transaction.account_number} </b>. </td>
                    </tr>
                    <tr> <td><br /> Title <b>${transaction.fund_account}</b> maintained with <b> ${transaction.bank} ${branchCity?branchName +" "+ branchCity.replace(".",""):transaction.branch} </b>  </td> </tr>
            </table>
            <br />
            <div>
                This is to inform you that deduction of withholding tax is not applied on the profit of above transaction, as mutual funds are exempted from withholding tax as per Clause (47B)
                of Part IV of Second Schedule of Income Tax Ordinance 2001
            </div> 
            <br />
            <div>Regards,</div>
           
            <br />
            <br />
            <br />
            <table style="width: 100%;">
            <tr>
                <td></td>
                <td >
                    <div style="border-top:1px solid #000; text-align: center;">Authorized Signatory</div> 
                </td>
                <td style="width: 40%;"> </td>
                <td>
                    <div style="border-top:1px solid #000; text-align: center;">Authorized Signatory</div> 
                </td>
                <td></td>
            </tr>
        </table>
    </body>
    </html>
    `
}
